import { categoryActions } from "./categories-slice";
import { uiActions } from "../ui-slice";

export const GetCategories = (email, showNotification) => {
  return async (dispatch) => {
   if (showNotification !== undefined && showNotification === true) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Cargando información",
          message: "Se esta solicitando la información al servidor.",
        })
      );
    }
    const GetCategoriesInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/course/category/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            userName: email,
            
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetCategoriesInfo();
      if (response.result.errorCode === "OK") {
        
        dispatch(
          categoryActions.setCategories({
            categories: [
              {
                id: 3,
                category: 'Todos',
                status: 'Activo',
                userName: ''
              },
              ...response.data.map((category) => ({
                ...category,
                status: category.status === true ? "Activo" : "Inactivo",
              }))
            ]
          })
      
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          categoryActions.setCategories({
            statues: [],
          })
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};